module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-template __base"
  }, [(_vm.product) ? _c('product-detail', {
    attrs: {
      "title": _vm.title,
      "product": _vm.product
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f2c7875","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/products/base.vue
// module id = 1143
// module chunks = 0